var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-doctor-form',{ref:"form",staticClass:"pt-doctor-form__withData",attrs:{"allMembers":_vm.allMembers,"doctorDetail":_vm.doctorDetail,"isEdit":_vm.isEdit,"company":_vm.company,"hospitalList":_vm.hospitalList}})}
var staticRenderFns = []

export { render, staticRenderFns }